/**
 * @module analyze ui
 */
import { createReducer } from '@reduxjs/toolkit';
import { analyzeSpecs, analyzeTypes } from '~/config/settings/reporting.settings';
import { uiActions } from '~/behaviors/actions/ui.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { convert } from '~/tools/convert';

const defaultState = {
  type: analyzeTypes.DISTRIBUTION,
  spec: analyzeSpecs.PERCENT,
  sortBy: 'percent',
  sortType: 'desc',
  requestHierarchyAttribute: false,
  hideEmpty: false,
};

const reset = () => defaultState;

const changeUI = (state, action) => {
  const updates = action?.payload || {};
  // @ts-expect-error TS(2345): Argument of type 'string[]' is not assignable to p... Remove this comment to see the full error message
  const sanitizedAttrs = convert.pick(updates, Object.keys(defaultState));

  return {
    ...state,
    ...sanitizedAttrs,
  };
};

const analyzeUI = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(uiActions.changeAnalyzeUI, changeUI);
});

export default analyzeUI;
